module.exports = __webpack_public_path__ + "img/sm-chat.22e9cbc6.svg";